export default {
      id: "sli-edit-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.cf73de4e.svg#sli-edit",
      toString: function () {
        return this.url;
      }
    }